var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { noop } from 'lodash';
import CentralizedLandingPageCard from '../centralized-landing-page-card/CentralizedLandingPageCard';
import useCentralizedLandingPageCardsHook from './useCentralizedLandingPageCardsHook';
var CentralizedLandingPageCards = function (_a) {
    var _b = _a.onClickOutSide, onClickOutSide = _b === void 0 ? noop : _b;
    var reportConfigs = useCentralizedLandingPageCardsHook().reportConfigs;
    var modifiedReportConfigs = reportConfigs.map(function (config) { return (__assign(__assign({}, config), { onNavigation: function () {
            if (!config.isSelected) {
                config.onNavigation();
            }
            onClickOutSide();
        } })); });
    return (<div className="c-centralized-landing-page__content">
      {modifiedReportConfigs.map(function (config) { return (<CentralizedLandingPageCard key={config.text} {...config}/>); })}
    </div>);
};
export default CentralizedLandingPageCards;
